import { render, staticRenderFns } from "./dailyActive.vue?vue&type=template&id=19767862&scoped=true&"
import script from "./dailyActive.vue?vue&type=script&lang=js&"
export * from "./dailyActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19767862",
  null
  
)

export default component.exports